import { API_URL } from './Constants';
import ApiService from './ApiService';

class CategoryApi {

    static createCategory = async (data) => {
        try {
            const response = await ApiService.postData(API_URL + "/cat/admin/create", data);
            return response;
        } catch (error) {
            console.error(error);
        }
    };

    static updateCategory = async (data) => {
        try {
            const response = await ApiService.postData(API_URL + "/cat/admin/update", data);
            return response;
        } catch (error) {
            console.error(error);
        }
    };

    static deleteCategory = async (categoryId) => {
        try {
            const response = await ApiService.deletePost(API_URL + `/cat/admin/delete/${categoryId}`);
            return response;
        } catch (error) {
            console.error(error);
        }
    };
}
export default CategoryApi;
